export var valuesPlaylistStateEnum = ["Assigned", "Started", "Finished"];
/*

*/ 
//# sourceMappingURL=PlaylistStateEnum.js.map